"use strict";
/**
 * Administration Route (Vía de administración) Enums
 *
 * Single source of truth for the route of administration used in controlled
 * (Grupo I) prescription metadata and the SITPV portal "Tratamiento" field.
 * Stored value is language-independent; the label is the Spanish display text
 * (also what gets copied into the portal). See GH#425.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMINISTRATION_ROUTE_LABELS = exports.AdministrationRoute = void 0;
var AdministrationRoute;
(function (AdministrationRoute) {
    AdministrationRoute["oral"] = "oral";
    AdministrationRoute["intravenous"] = "intravenous";
    AdministrationRoute["intramuscular"] = "intramuscular";
    AdministrationRoute["subcutaneous"] = "subcutaneous";
    AdministrationRoute["ophthalmic"] = "ophthalmic";
    AdministrationRoute["otic"] = "otic";
    AdministrationRoute["inhaled"] = "inhaled";
    AdministrationRoute["topical"] = "topical";
})(AdministrationRoute || (exports.AdministrationRoute = AdministrationRoute = {}));
/** Spanish display labels for AdministrationRoute */
exports.ADMINISTRATION_ROUTE_LABELS = {
    [AdministrationRoute.oral]: 'Oral',
    [AdministrationRoute.intravenous]: 'Intravenosa (IV)',
    [AdministrationRoute.intramuscular]: 'Intramuscular (IM)',
    [AdministrationRoute.subcutaneous]: 'Subcutánea (SC)',
    [AdministrationRoute.ophthalmic]: 'Oftálmica',
    [AdministrationRoute.otic]: 'Ótica',
    [AdministrationRoute.inhaled]: 'Inhalada',
    [AdministrationRoute.topical]: 'Tópica / Local',
};
